<template>
  <v-card outlined>
    <v-card-text class="pa-2 pa-sm-4">
      <v-row dense align="center" class="mb-2">
        <v-col cols="auto">
          <span class="text-h6">События СКУД</span>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-btn icon @click="getEvents">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6" md="3">
          <v-menu
            v-model="menuDateBegin"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="date.begin"
                v-bind="attrs"
                v-on="on"
                prepend-icon="mdi-calendar"
                label="Дата с"
                readonly
                clearable
                dense
                hide-details
              />
            </template>
            <v-date-picker v-model="date.begin" />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-menu
            v-model="menuDateEnd"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="date.end"
                v-bind="attrs"
                v-on="on"
                prepend-icon="mdi-calendar"
                label="Дата по"
                readonly
                clearable
                dense
                hide-details
              />
            </template>
            <v-date-picker v-model="date.end" />
          </v-menu>
        </v-col>

        <v-col cols="6" sm="6" md="3">
          <v-menu
            :close-on-content-click="false"
            offset-y
            min-width="auto"
            v-model="menuTimeBegin"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                label="Время с"
                prepend-icon="mdi-clock-time-four-outline"
                clearable
                readonly
                dense
                hide-details
                v-model="time.begin"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-time-picker v-model="time.begin" format="24hr" />
          </v-menu>
        </v-col>

        <v-col cols="6" sm="6" md="3">
          <v-menu
            :close-on-content-click="false"
            offset-y
            min-width="auto"
            v-model="menuTimeEnd"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                label="Время по"
                v-model="time.end"
                prepend-icon="mdi-clock-time-four-outline"
                clearable
                dense
                hide-details
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-time-picker v-model="time.end" format="24hr" />
          </v-menu>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-select
            v-model="selectPointId"
            :items="accessPoints"
            item-text="name"
            item-value="id"
            label="Точка доступа"
            clearable
            dense
            hide-details
            @change="onPointChange"
          />
        </v-col>

        <v-col cols="12" sm="6">
          <v-select
            v-model="selectControllerId"
            :items="controllersItemsSelect"
            item-text="name"
            item-value="id"
            label="Контроллер"
            clearable
            dense
            hide-details
            @change="onFilterChange"
          />
        </v-col>

        <v-col cols="12" sm="6">
          <v-select
            v-model="selectEventType"
            @change="onFilterChange"
            :items="eventTypes"
            item-text="text"
            item-value="value"
            label="Тип события"
            clearable
            dense
            hide-details
          />
        </v-col>
      </v-row>

      <v-row v-if="session.permission.isAllow('elem', 'download_data')" dense>
        <v-col>
          <v-btn
            text
            color="primary"
            @click="
              downloadAccessEvent({
                userId,
                time,
                date,
                selectControllerId,
                controller: controllersItemsSelect.find(
                  c => c.id === selectControllerId
                ),
                selectEventType,
                totalElements: events.totalElements
              })
            "
          >
            <v-icon left>mdi-cloud-download</v-icon>
            Выгрузить отчет по СКУД
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text>
      <v-data-table
        dense
        :headers="headers"
        :items="events.content"
        :options.sync="eventsOptions"
        :server-items-length="events && events.totalElements"
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [15, 25, 50] }"
      >
        <template #item.date="{item}">
          {{ dateFormatted(item.date) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { groupBy, sortBy } from "lodash";
import { getAcsEvent } from "@/services/user.service";
import {
  getControllers,
  getAccessPointController
} from "@/services/device.service";
import { downloadAccessEvent } from "@/services/accessEventExport.service.js";
import { session } from "../../services/session.service";
import { todayIso } from "../../utils/date-format";

export default {
  name: "AccessEventInformation",

  props: {
    userId: { required: true }
  },

  data() {
    return {
      loading: false,
      controllers: [],
      controllersItemsSelect: [],
      accessPoints: [],
      selectPointId: null,
      selectControllerId: null,
      session: session,

      headers: [
        { text: "Дата", value: "date" },
        { text: "Контроллер", value: "controllerName" },
        { text: "Шлюз", value: "gatewayName" },
        { text: "Событие", value: "eventName" }
      ],

      events: {},
      eventsOptions: {},

      menuDateBegin: false,
      menuDateEnd: false,
      date: {
        begin: todayIso(),
        end: todayIso()
      },

      menuTimeBegin: false,
      menuTimeEnd: false,
      time: {
        begin: "00:00",
        end: "23:59"
      },

      selectEventType: null,
      eventTypes: [
        { text: "Вход", value: "1" },
        { text: "Выход", value: "2" },
        { text: "Доступ запрещен", value: "200" }
      ]
    };
  },

  watch: {
    eventsOptions: {
      handler() {
        this.getEvents();
      }
    },

    date: {
      handler() {
        this.eventsOptions.page = 1;
        this.getEvents();
      },
      deep: true
    },

    time: {
      handler() {
        this.eventsOptions.page = 1;
        this.getEvents();
      },
      deep: true
    }
  },

  mounted() {
    this.loadAccessPoints();
    this.getControllers();
  },

  methods: {
    downloadAccessEvent,

    async loadAccessPoints() {
      try {
        this.accessPoints = await getAccessPointController();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    onPointChange() {
      this.selectControllerId = null;
      this.getControllers();
      this.onFilterChange();
    },

    onFilterChange() {
      this.eventsOptions = { ...this.eventsOptions, page: 1 };
    },

    async getEvents() {
      this.loading = true;
      try {
        const { page, itemsPerPage } = this.eventsOptions;

        const params = {
          page: page - 1,
          size: itemsPerPage
        };

        if (this.selectPointId !== null) {
          params.pId = this.selectPointId;
        }

        if (this.selectControllerId !== null) {
          params.cId = this.selectControllerId;
        }

        if (this.date.begin) params.dateBegin = this.date.begin;
        if (this.date.end) params.dateEnd = this.date.end;

        params.timeBegin = this.time.begin;
        params.timeEnd = this.time.end;

        if (this.selectEventType) {
          params.typeEvent = this.selectEventType;
        }

        this.events = await getAcsEvent(this.userId, params);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      } finally {
        this.loading = false;
      }
    },

    async getControllers() {
      try {
        this.controllers = await getControllers();

        let filtered = this.controllers
          .filter(c => c.name !== null)
          .filter(c => c.type === 5 || c.type === 0);
        if (this.selectPointId) {
          filtered = filtered.filter(
            c => c.accessPoint?.id === this.selectPointId
          );
        }
        const grouped = groupBy(filtered, c => c.accessPoint?.name || "—");
        const result = [];
        const sortedGroups = sortBy(Object.keys(grouped)).reverse();
        for (const groupName of sortedGroups) {
          const sorted = sortBy(grouped[groupName], ["name"]);
          for (const c of sorted) {
            result.push({
              name: `${c.name}`,
              id: c.id
            });
          }
        }
        this.controllersItemsSelect = result;
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    dateFormatted(date) {
      if (date) {
        return new Date(date).toLocaleString("ru-RU");
      }
    }
  }
};
</script>
